import React from 'react'
import { v4 as uuid } from 'uuid'
import { DragDropContext } from 'react-beautiful-dnd'
import { Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import * as Yup from 'yup'

import { Button } from '@/components/buttons/Button'
import { closeModal } from '@/reducers/ui/ui.redux'

import { EditMeasuresRow } from './EditMeasuresRow'
import { handleDrag } from '../helpers/index'
import { ModalFields } from './ModalFields'
import { measuresSchema } from './scorecardConfig.schema'

import './editSectionsForm.css'

export const EditMeasuresForm = ({
  measures = [],
  handleSubmit,
  updateMeasuresNow,
  removeFromObject,
  updateStatusInObject,
  updateNameInObject,
  addNewMeasure,
}) => {
  const dispatch = useDispatch()
  const { loading } = useSelector((state) => state.scorecards)
  const onSubmit = async (values) => {
    await handleSubmit(values)
  }

  const handleAddMeasure = (push, items) => {
    const scorecardSectionId = items[0]?.scorecard_section_id
    const newMeasure = {
      name: '',
      active: true,
      deleted: false,
      scorecard_section_id: scorecardSectionId,
      order_id: items.length,
      id: uuid(),
    }
    addNewMeasure(newMeasure)
  }

  const onDragEnd = async (result) => {
    const { destination, source } = result
    if (!destination) {
      return
    }
    if (destination.droppableId === source.droppableId && destination.index === source.index) {
      return
    }
    const updateMeasures = handleDrag(result, measures)
    await updateMeasuresNow(updateMeasures)
  }

  const shape = Yup.object().shape(measuresSchema)

  return (
    <Formik
      enableReinitialize
      initialValues={{ measures }}
      validationSchema={shape}
      onSubmit={onSubmit}
    >
      {({ values, errors, handleSubmit: formikHandleSubmit }) => {
        return (
          <form onSubmit={formikHandleSubmit}>
            <div className="edit-scorecard-form__container" data-testid="manage-measures-form">
              <div className="edit-scorecard-form__header">
                <div className="edit-scorecard-form__drag-handle" />
                <div className="edit-scorecard-form__header-name">Measures</div>
                <div className="edit-scorecard-form__info-spacer" />
                <div className="edit-scorecard-form__header-status">Status</div>
                <div className="edit-scorecard-form__delete-spacer" />
              </div>
              <DragDropContext onDragEnd={onDragEnd}>
                <ModalFields
                  items={values.measures}
                  name="measures"
                  RowComponent={EditMeasuresRow}
                  errors={errors}
                  handleAddItem={handleAddMeasure}
                  addItemLabel="Add Measure"
                  removeFromObject={removeFromObject}
                  updateStatusInObject={updateStatusInObject}
                  updateNameInObject={updateNameInObject}
                />
              </DragDropContext>
            </div>
            <div className="modal-footer">
              <Button
                data-testid="edit-measures-form__cancel-button"
                onClick={() => dispatch(closeModal())}
              >
                Cancel
              </Button>
              <Button
                data-testid="save_modal"
                type="submit"
                brand
                loading={loading.scorecards}
                disabled={loading.scorecards || !isEmpty(errors)}
                disabledTooltip="Please fix errors before submitting"
              >
                Save
              </Button>
            </div>
          </form>
        )
      }}
    </Formik>
  )
}
